// src/locales/si/expenses.js
export const expenses = {
  // Page titles
  manageExpenses: 'වියදම් කළමනාකරණය',
  viewAndManageExpenses: 'ව්‍යාපාරික වියදම් සටහන් කර ලුහුබඳින්න',

  // Statistics
  totalExpenses: 'මුළු වියදම් ගණන',
  totalAmount: 'මුළු මුදල',
  filteredTotal: 'පෙරහන් කළ මුළු මුදල',

  // Actions
  recordNewExpense: 'වියදමක් සටහන් කරන්න',
  editExpense: 'වියදම සංස්කරණය කරන්න',
  deleteExpense: 'වියදම මකන්න',
  createExpense: 'වියදම සුරකින්න',
  updateExpense: 'වියදම යාවත්කාලීන කරන්න',

  // Fields
  expenseDate: 'වියදම් දිනය',
  category: 'කාණ්ඩය',
  subCategory: 'උප කාණ්ඩය',
  selectCategory: 'කාණ්ඩය තෝරන්න',
  selectSubCategory: 'උප කාණ්ඩය තෝරන්න (අවශ්‍ය නොවේ)',
  title: 'මාතෘකාව / විස්තරය',
  amount: 'මුදල',
  paymentMethod: 'ගෙවීම් ක්‍රමය',
  notes: 'සටහන්',
  createdBy: 'සටහන් කළේ',

  // Placeholders
  enterTitle: 'වියදමේ මාතෘකාව හෝ විස්තරය ඇතුළත් කරන්න',
  enterAmount: 'මුදල ඇතුළත් කරන්න',
  enterNotes: 'මෙම වියදම පිළිබඳ අමතර සටහන්...',

  // Payment methods
  paymentMethods: {
    cash: 'මුදල්',
    bank_transfer: 'බැංකු හුවමාරුව',
    credit_card: 'ක්‍රෙඩිට් කාඩ්',
    cheque: 'චෙකය',
    mobile_payment: 'ජංගම ගෙවීම',
    other: 'අනෙකුත්',
  },

  // Search and filters
  searchExpenses: 'මාතෘකාව අනුව සොයන්න...',
  allCategories: 'සියලු කාණ්ඩ',
  allPaymentMethods: 'සියලු ගෙවීම් ක්‍රම',
  dateFrom: 'ආරම්භක දිනය',
  dateTo: 'අවසාන දිනය',

  // Summary
  showingTotal: 'පෙරහන් කළ ප්‍රතිඵල සඳහා මුළු මුදල',

  // Messages
  expenseCreatedSuccessfully: 'වියදම සාර්ථකව සටහන් කරන ලදි',
  expenseUpdatedSuccessfully: 'වියදම සාර්ථකව යාවත්කාලීන කරන ලදි',
  expenseDeletedSuccessfully: 'වියදම සාර්ථකව මකා ඇත',
  failedToLoadExpenses: 'වියදම් පූරණය අසාර්ථක විය',
  failedToLoadCategories: 'වියදම් කාණ්ඩ පූරණය අසාර්ථක විය',
  failedToCreateExpense: 'වියදම සටහන් කිරීම අසාර්ථක විය',
  failedToUpdateExpense: 'වියදම යාවත්කාලීන කිරීම අසාර්ථක විය',
  failedToDeleteExpense: 'වියදම මකා දැමීම අසාර්ථක විය',

  // Empty states
  noExpensesYet: 'වියදම් සටහන් කර නොමැත',
  noExpensesYetDescription: 'ඔබගේ පළමු වියදම සටහන් කර ව්‍යාපාරික වියදම් ලුහුබැඳීම ආරම්භ කරන්න.',
  noExpensesFound: 'වියදම් හමු නොවුණි',
  noExpensesFoundDescription: 'ඔබගේ වර්තමාන පෙරහන්වලට ගැලපෙන වියදම් නොමැත. සෙවීම් නිර්ණායක සකස් කර බලන්න.',

  // Delete confirmation
  confirmDelete: 'ඔබට මෙම වියදම මකා දැමීමට අවශ්‍යද?',
  confirmDeleteDescription: 'මෙම ක්‍රියාව අහෝ කළ නොහැක.',

  // Validation
  validation: {
    categoryRequired: 'වියදම් කාණ්ඩය අවශ්‍යයි',
    titleRequired: 'මාතෘකාව අවශ්‍යයි',
    titleMinLength: 'මාතෘකාව අවම වශයෙන් අක්ෂර 2 ක් විය යුතුය',
    amountRequired: 'මුදල අවශ්‍යයි',
    amountPositive: 'මුදල ධනාත්මක සංඛ්‍යාවක් විය යුතුය',
    dateRequired: 'වියදම් දිනය අවශ්‍යයි',
    paymentMethodRequired: 'ගෙවීම් ක්‍රමය අවශ්‍යයි',
    fixErrors: 'කරුණාකර පෝරමයේ දෝෂ නිවැරදි කරන්න',
  },
};
